import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getCurrentDateTime, getDateTimeFrom } from '../../helpers/datetime'
import { selectCompanyInfo } from '../common/header/companyInfo/store/slice'
import useGetSettingFinancialStatement from '../financial/common/useGetSettingFinancialStatement'
import {
  getAlertHighlight,
  getCompanyAlerts,
  getFilingStatus,
  getIndustryTopYear,
  getKeyFinancials,
  getOwnershipAndGroup,
  getOwnershipAndGroupInfo,
  getRecentNews,
  getRevenue,
  getScore,
  getSummaryHighlight,
  getSummaryOverview,
  getTopComparablePlayers,
  getTopIndustryPlayers,
} from './store/thunk'

const useCallApi = () => {
  const dispatch = useDispatch()

  const settings = useGetSettingFinancialStatement()
  const { organizationId, fiscalYearEnd, companyType } =
    useSelector(selectCompanyInfo)
  const locale = useSelector((state) => state.i18n.locale)
  const fiscalYear = new Date(fiscalYearEnd || Date.now()).getFullYear()

  useEffect(() => {
    if (!organizationId) return
    dispatch(
      getSummaryHighlight({ OrganizationId: organizationId, companyType }),
    )
    dispatch(getRevenue({ OrganizationId: organizationId, ...settings }))
    dispatch(getIndustryTopYear()).then((action) => {
      const year = action.payload || fiscalYear
      dispatch(
        getTopIndustryPlayers({
          companyType,
          OrganizationId: organizationId,
          Top: 10,
          Year: year,
          SortByRevenue: true,
        }),
      )
    })
    dispatch(
      getScore({ OrganizationId: organizationId, TimeFrequency: 'Monthly' }),
    )
    dispatch(getRecentNews({ OrganizationId: organizationId }))
    dispatch(getOwnershipAndGroupInfo({ OrganizationId: organizationId }))
    dispatch(getOwnershipAndGroup({ OrganizationId: organizationId }))
    dispatch(
      getKeyFinancials({
        organizationId,
        ...settings,
      }),
    )
    dispatch(getFilingStatus({ OrganizationId: organizationId }))
    dispatch(getTopComparablePlayers({ OrganizationId: organizationId }))
    dispatch(getSummaryOverview({ OrganizationId: organizationId }))
    dispatch(
      getAlertHighlight({
        organizationId,
        fromDate: getDateTimeFrom(new Date(), -1, 'years'),
        toDate: getCurrentDateTime(),
      }),
    )
    dispatch(
      getCompanyAlerts({
        OrganizationId: organizationId,
        Page: 1,
        PageSize: 5,
      }),
    )
  }, [locale, organizationId, fiscalYear])
}

export default useCallApi
